import React, { useState } from 'react';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';
import { useAlert } from '../../../../../../context/AlertContext';
import voucherImportServices from '../voucherImportServices';
import moment from 'moment/moment';

/// This is Not completed this is just a copy of ladger import 

function VoucherImportPage() {
    const [file, setFile] = useState(null);
    const [saving, setSavingStatus] = useState(false);
    const [responseMessage, setResponseMessage] = useState(null);
    const [errors, setErrors] = useState([]);
    const [error, setError] = useState("");
    const [jsonData, setJsonData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    
    const [extractedVoucher, setExtractedVoucher] = useState([]);

    const [voucherUploadStatus, setVoucherUploadStatus] = useState('idle'); // 'idle' | 'uploading' | 'success' | 'error'

    // Progress tracking states for chunk uploading vouchers
    const [uploadProgress, setUploadProgress] = useState({ current: 0, total: 0 });
    const [progressPercentage, setProgressPercentage] = useState(0);

    const { AppAlert } = useAlert();

    // Helper to clean Tally control characters like \u0004
    const cleanTallyText = (text) => {
        if (!text || typeof text !== 'string') return text;
        return text.replace(/\\u[0-9a-fA-F]{4}|\u0004|[\u0000-\u001F\u007F-\u009F]/g, '').trim();
    };


    // Helper to extract numeric value and unit from strings like " 1.00 Pcs" or "423.73/Pcs"
    const parseQtyAndUnit = (qtyString) => {
        if (!qtyString) return { qty: "", uom: "" };
        const cleaned = cleanTallyText(qtyString);
        // Matches numbers (including decimals) and text unit separately
        const match = cleaned.match(/([\d.]+)\s*(.*)/);
        if (match) {
            return { qty: match[1], uom: match[2].trim() };
        }
        return { qty: cleaned, uom: "" };
    };

    const parseRate = (rateString) => {
        if (!rateString) return "";
        const cleaned = cleanTallyText(rateString);
        // Extracts price before the slash (e.g., "423.73/Pcs" -> "423.73")
        return cleaned.split('/')[0].trim();
    };

    // Helper to extract and clean address lines from Tally address array
    const parseAddress = (addressArray) => {
        if (!Array.isArray(addressArray)) return [];
        return addressArray
            .filter(item => typeof item === 'string') // Ignore metadata object
            .map(line => cleanTallyText(line))
            .filter(line => line.length > 0); // Remove empty strings
    };


    /**
     * Extracts and maps inventory line items into structured voucher items.
     * @param {Array} allinventoryentries - The inventory entries array from Tally data.
     * @returns {Array} Processed voucher items.
     */
    const extractVoucherItems = (allinventoryentries) => {
        if (!Array.isArray(allinventoryentries)) return [];

        return allinventoryentries.map(lineItem => {
            const { qty, uom } = parseQtyAndUnit(lineItem.billedqty || lineItem.actualqty);
            const parsedQty = parseFloat(qty) || 1;

            let rawPrice = lineItem.rate ? parseRate(lineItem.rate) : "";
            let lineAmount = lineItem.amount ? (parseFloat(cleanTallyText(lineItem.amount)) || 0) : 0;
            let gstInclusiveRate = lineItem.inclvatrate ? parseRate(lineItem.inclvatrate) : "";

            // Extract GST Rate safely
            let gstRate = "0";
            if (Array.isArray(lineItem.ratedetails)) {
                const igstObj = lineItem.ratedetails.find(r => cleanTallyText(r.gstratedutyhead) === "IGST");
                if (igstObj && igstObj.gstrate) {
                    gstRate = cleanTallyText(igstObj.gstrate);
                } else {
                    const cgstObj = lineItem.ratedetails.find(r => cleanTallyText(r.gstratedutyhead) === "CGST");
                    const sgstObj = lineItem.ratedetails.find(r => cleanTallyText(r.gstratedutyhead) === "SGST/UTGST");
                    const cgst = cgstObj ? parseFloat(cleanTallyText(cgstObj.gstrate)) || 0 : 0;
                    const sgst = sgstObj ? parseFloat(cleanTallyText(sgstObj.gstrate)) || 0 : 0;
                    if (cgst > 0 || sgst > 0) {
                        gstRate = (cgst + sgst).toString();
                    }
                }
            }

            const taxPercent = parseFloat(gstRate) || 0;

            // EXCEPTION HANDLING 1: If rate/amount are missing but inclvatrate is available
            if ((!rawPrice || rawPrice === "") && gstInclusiveRate && parsedQty > 0) {
                const inclRateNum = parseFloat(gstInclusiveRate) || 0;
                const basePrice = inclRateNum / (1 + (taxPercent / 100));
                //rawPrice = basePrice;  // Updaing becasue of  // GIS/25-26/257 issue
                rawPrice= 0;
                // lineAmount = basePrice * parsedQty; //// Updaing becasue of  // GIS/25-26/257 issue
                lineAmount = 0; //basePrice * parsedQty;
                // Daini Added this Line Becasue no rate is available like case // GIS/25-26/257 issue
                gstInclusiveRate = 0;
            } 
            // EXCEPTION HANDLING 2: If inclvatrate is missing, calculate it from base rate
            else if (!gstInclusiveRate && rawPrice) {
                const basePrice = parseFloat(rawPrice) || 0;
                gstInclusiveRate = (basePrice + (basePrice * taxPercent / 100)).toFixed(2);
            }
            // EXCEPTION HANDLING 3: If everything (rate, amount, inclvatrate) is missing (like the Monitor case)
            else if ((!rawPrice || rawPrice === "") && (!gstInclusiveRate || gstInclusiveRate === "") && lineAmount === 0) {
                rawPrice = 0;
                lineAmount = 0;
                gstInclusiveRate = 0;
            }
            // EXCEPTION HANDLING 4: If amount is present but rate is missing
            else if ((!rawPrice || rawPrice === "") && lineAmount > 0 && parsedQty > 0) {
                //rawPrice = lineAmount / parsedQty; // Updaing becasue of  // GIS/25-26/257 issue
                rawPrice = 0;
                gstInclusiveRate = (rawPrice + (rawPrice * taxPercent / 100)).toFixed(2);
            }

            const parsedPrice = parseFloat(rawPrice) || 0;
            const finalAmount = lineAmount > 0 ? lineAmount : parsedPrice * parsedQty;
            const gstAmount = (finalAmount * (taxPercent / 100)).toFixed(2);
            const parsedInclusiveRate = parseFloat(gstInclusiveRate) || 0;

            const calculatedTotal = parsedInclusiveRate > 0 ? parsedInclusiveRate * parsedQty : finalAmount + parseFloat(gstAmount);

            return {
                stockitemname: cleanTallyText(lineItem.stockitemname || ""),
                billingType: cleanTallyText(lineItem.gstovrdntypeofsupply || ""),
                gsthsnname: cleanTallyText(lineItem.gsthsnname || ""),
                qty: parsedQty,
                uom: uom,
                price: parsedPrice.toFixed(2),             // Converted to string (e.g., "12200.00")
                gstRate: gstRate,                          // Already a string
                amount: finalAmount.toFixed(2),            // Converted to string (e.g., "24400.00")
                gstAmount: gstAmount,                      // Already a string from .toFixed(2)
                totalAmount: calculatedTotal.toFixed(2),   // Converted to string (e.g., "28792.00")
            };
        });
    };

    const extractTallyData = (data) => {
        const vouchers = [];

        if (!data || !data.tallymessage) return { vouchers };

        data.tallymessage.forEach(item => {
            const type = item.metadata?.type;
            const action = item.metadata?.action;
            if (type === "Voucher" && action === "Create") {
                

                let voucherItems = [];
                voucherItems = extractVoucherItems(item.allinventoryentries);

                const allLedgerEntries = Array.isArray(item.allledgerentries)
                    ? item.allledgerentries.map(ledgerEntry => {
                        if(ledgerEntry.inventoryallocations){
                            voucherItems = extractVoucherItems(ledgerEntry.inventoryallocations);
                        }
                        

                        return {
                            ledgerName: cleanTallyText(ledgerEntry.ledgername || ""),
                            amount: cleanTallyText(ledgerEntry.amount || ""),
                            bankallocations: ledgerEntry.bankallocations || [],
                            //inventoryallocations: ledgerEntry.inventoryallocations || [],
                        }
                    })
                    : [];


                /*
                const ledgerEntries = Array.isArray(item.ledgerentries)
                    ? item.ledgerentries.map(ledgerEntry => {
                        return {
                            ledgerName: cleanTallyText(ledgerEntry.ledgername || ""),
                            amount: cleanTallyText(ledgerEntry.amount || ""),
                        }
                    })
                    : [];
                */




                vouchers.push({
                    voucherNo: cleanTallyText(item?.vouchernumber) || "",
                    voucherType: cleanTallyText(item.metadata?.vchtype) || "",
                    partyName: cleanTallyText(item?.partyledgername) || "",
                    gstregistrationtype: cleanTallyText(item?.gstregistrationtype) || "",
                    placeofsupply: cleanTallyText(item?.placeofsupply) || "",
                    partyPan: cleanTallyText(item?.buyerpinnumber) || "",
                    voucherDate: item?.date ? moment(item.date,"YYYYMMDD").format("YYYY-MM-DD") : null,

                    created_at: item?.date ? moment(item.date,"YYYYMMDD").format("YYYY-MM-DD HH:mm:ss") : null,
                    updated_at:item?.date ? moment(item.vchstatusdate,"YYYYMMDD").format("YYYY-MM-DD HH:mm:ss") : null,

                    partyGstin: cleanTallyText(item?.consigneegstin) || "",
                    consigneemailingname: cleanTallyText(item.consigneemailingname || ""),
                    consigneepincode: cleanTallyText(item?.consigneepincode) || "",
                    consigneestatename: cleanTallyText(item?.consigneestatename) || "",
                    billingAddress: parseAddress(item.address), // Extracted address lines array
                    shippingAddress: parseAddress(item.basicbuyeraddress), // Extracted address lines array

                    narration : cleanTallyText(item?.narration) || "",
                    //updateddatetime : cleanTallyText(item?.updateddatetime) || "NOTAVAIL",
                    voucherItems: voucherItems,
                    allLedgerEntries:allLedgerEntries,
                    //ledgerEntries:ledgerEntries,
                });
            }
        });

        return { vouchers };
    };

    // Handle file selection and parsing
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile); 
        setResponseMessage(null);
        setErrors([]);
        setError("");
        setJsonData(null);
        setExtractedVoucher([]);
        setVoucherUploadStatus('idle');

        if (!selectedFile) return;

        if (selectedFile.type !== "application/json" && !selectedFile.name.endsWith('.json')) {
            setError('Please select a valid JSON file.');
            AppAlert('Please select a valid JSON file.', 'error');
            return;
        }

        setIsLoading(true);
        const reader = new FileReader();

        reader.onload = (event) => {
            try {
                const parsedData = JSON.parse(event.target.result);
                setJsonData(parsedData); 
                const { vouchers } = extractTallyData(parsedData);
                setExtractedVoucher(vouchers);
            } catch (err) {
                setError('Failed to parse JSON. Please check file formatting.');
                AppAlert('Failed to parse JSON.', 'error');
            } finally {
                setIsLoading(false);
            }
        };

        reader.onerror = () => {
            setError('Error reading the file.');
            setIsLoading(false);
        };
        reader.readAsText(selectedFile);
    };

    // Two-part Upload Script: 1. Groups (in one go) -> 2. Vouchers (in chunks)
    const handleUploadToServer = async () => {
        if (!extractedVoucher.length) return;

        setSavingStatus(true);
        setError("");
        setResponseMessage(null);

        try {
            
            if (extractedVoucher.length > 0) {
                setVoucherUploadStatus('uploading');
                const totalItems = extractedVoucher.length;
                const CHUNK_SIZE = 500;
                let uploadedCount = 0;

                setUploadProgress({ current: 0, total: totalItems });
                setProgressPercentage(0);

                for (let i = 0; i < totalItems; i += CHUNK_SIZE) {
                    const chunk = extractedVoucher.slice(i, i + CHUNK_SIZE);
                    
                    await new Promise((resolve, reject) => {
                        voucherImportServices.importTallyVouchers({ vouchers: chunk })
                            .then(res => {
                                uploadedCount += chunk.length;
                                setUploadProgress({ current: uploadedCount, total: totalItems });
                                setProgressPercentage(Math.round((uploadedCount / totalItems) * 100));
                                resolve(res);
                            })
                            .catch(err => {
                                reject(err);
                            });
                    });
                }
                setVoucherUploadStatus('success');
            } else {
                setVoucherUploadStatus('success');
            }

            AppAlert("Tally Data Import successful!");
            setResponseMessage('Groups and Vouchers imported successfully!');

        } catch (err) {
            console.log(err);
            setError(err?.msg || 'Upload failed');
            AppAlert(err?.msg || "Upload failed", "error");
        } finally {
            setSavingStatus(false);
        }
    };

    return (
        <FinanceLayout>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <h1>Voucher Import</h1>
                        <div className="mb-3">
                            <label htmlFor="formFile" className="form-label">Upload JSON File</label>
                            <input className="form-control" type="file" id="formFile" accept=".json" onChange={handleFileChange} />
                        </div>
                        
                        {error && <div className="alert alert-danger">{error}</div>}
                        {responseMessage && <div className="alert alert-success">{responseMessage}</div>}
                        
                        <button 
                            type="button" 
                            className="btn btn-primary" 
                            onClick={handleUploadToServer}
                            disabled={saving || isLoading || (!extractedVoucher?.length)}
                        >
                            {saving ? 'Processing Import...' : `Upload ${extractedVoucher?.length || 0} Vouchers)`}
                        </button>


                        {/* Step 2 Status Indicator & Progress Bar: Vouchers */}
                        {(voucherUploadStatus !== 'idle' ) && (
                            <div className="mt-3">
                                <div className="d-flex align-items-center mb-1">
                                    <span className="me-2 fw-bold">2. Vouchers:</span>
                                    {voucherUploadStatus === 'uploading' && <span className="text-muted">Uploading records in batches...</span>}
                                    {voucherUploadStatus === 'success' && <span className="text-success fw-bold">✓ Vouchers Uploaded Successfully</span>}
                                </div>
                                
                                {voucherUploadStatus === 'uploading' && (
                                    <>
                                        <div className="d-flex justify-content-between mb-1">
                                            <small>{uploadProgress.current} / {uploadProgress.total} records</small>
                                            <small>{progressPercentage}%</small>
                                        </div>
                                        <div className="progress" style={{ height: '20px' }}>
                                            <div 
                                                className="progress-bar progress-bar-striped progress-bar-animated" 
                                                role="progressbar" 
                                                style={{ width: `${progressPercentage}%` }}
                                                aria-valuenow={progressPercentage} 
                                                aria-valuemin="0" 
                                                aria-valuemax="100"
                                            >
                                                {progressPercentage}%
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                <div className='row'>
                    {isLoading && (
                        <div className="col-12 text-center" style={{ marginTop: '20px' }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2">Reading and parsing JSON file...</p>
                        </div>
                    )}

                    {!isLoading && jsonData && (
                        <div className="col-12 mt-4">
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <div className="p-3 bg-light rounded">
                                        <h5>Extracted Vouchers Preview ({extractedVoucher?.length || 0}):</h5>
                                        <pre style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                            {JSON.stringify(extractedVoucher, null, 2)}
                                        </pre>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </FinanceLayout>
    );
}

export default VoucherImportPage;